
<div class="interior-menubar">
  <p-menubar [model]="menuItems" [style]="{'border':'none'}"></p-menubar>
  <app-draft *ngIf="draftRequest" [request]="draftRequest" (handler)="loadDraftFromAppDraft($event)"></app-draft>
  <app-template *ngIf="templateRequest" [txnType]="txnType" [request]="templateRequest" (handler)="loadTemplateFromAppTemplate($event)"></app-template>
</div>

